import { refreshIcons } from './utils.js';

export function initTheme() {
    const html = document.documentElement;
    const themeToggle = document.getElementById('theme-toggle');
    const themeIconContainer = document.getElementById('theme-icon-container');

    // Initial check
    if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
        html.classList.add('dark');
        updateThemeIcon(true);
    } else {
        html.classList.remove('dark');
        updateThemeIcon(false);
    }

    // Toggle event
    if (themeToggle) {
        themeToggle.addEventListener('click', toggleTheme);
    }

    function updateThemeIcon(isDark) {
        if (!themeIconContainer) return;

        themeIconContainer.style.opacity = '0';

        setTimeout(() => {
            themeIconContainer.innerHTML = `<i data-lucide="${isDark ? 'sun' : 'moon'}" class="w-4 h-4"></i>`;
            refreshIcons(themeIconContainer);

            requestAnimationFrame(() => {
                themeIconContainer.style.opacity = '1';
            });
        }, 50);
    }

    function toggleTheme() {
        const willBeDark = !html.classList.contains('dark');

        html.classList.toggle('dark');
        localStorage.setItem('theme', willBeDark ? 'dark' : 'light');
        updateThemeIcon(willBeDark);

        const favicon = document.getElementById('app-favicon');
        if (favicon && window.faviconPaths) {
            favicon.href = willBeDark ? window.faviconPaths.dark : window.faviconPaths.light;
        }
    }
}

// Auto init
document.addEventListener('DOMContentLoaded', initTheme);
